import axios from "axios";
import { BASE_URL } from "./axios";

export const META_PIXEL_ID =
  process.env.REACT_APP_META_PIXEL_ID || "2092001514739657";

const newEventId = () =>
  typeof crypto !== "undefined" && crypto.randomUUID
    ? crypto.randomUUID()
    : `evt_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;

const readCookie = (name) => {
  if (typeof document === "undefined") return "";
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : "";
};

const facebookClickId = () => {
  if (typeof window === "undefined") return "";
  const fbclid = new URLSearchParams(window.location.search).get("fbclid");
  if (!fbclid) return "";
  return `fb.1.${Date.now()}.${fbclid}`;
};

const sendConversionsApi = ({ eventName, eventID, params, userData }) => {
  const email =
    userData.email ||
    (typeof sessionStorage !== "undefined"
      ? sessionStorage.getItem("customer_id")
      : "") ||
    "";
  const payload = {
    event_name: eventName,
    event_id: eventID,
    event_source_url: typeof window !== "undefined" ? window.location.href : "",
    action_source: "website",
    custom_data: params,
    user_data: {
      email,
      phone: userData.phone || "",
      first_name: userData.first_name || userData.name || "",
      fbp: readCookie("_fbp"),
      fbc: readCookie("_fbc") || facebookClickId(),
      client_user_agent:
        typeof navigator !== "undefined" ? navigator.userAgent : "",
    },
  };

  axios
    .post(`${BASE_URL}/consult_ai_app/metacap/`, payload, { timeout: 4000 })
    .catch(() => {});
};

export function trackMetaEvent(eventName, params = {}, userData = {}) {
  if (typeof window === "undefined") return "";
  const eventID = newEventId();
  if (typeof window.fbq === "function") {
    window.fbq("track", eventName, params, { eventID });
  }
  sendConversionsApi({ eventName, eventID, params, userData });
  return eventID;
}

export function trackMetaPageView() {
  if (typeof window === "undefined" || typeof window.fbq !== "function") return;
  window.fbq("track", "PageView");
}

export function trackMetaSubscribe(value, currency = "INR", userData = {}) {
  const amount = Number(value);
  return trackMetaEvent(
    "Subscribe",
    {
      value: Number.isFinite(amount) ? amount : 0,
      currency,
    },
    userData,
  );
}
